import React from "react";

export default () => (
  <footer>
    <a href="https://xemono.life/#/" target="_brank" rel="noopener">
      <p>@Xemono</p>
    </a>
  </footer>
);
